import { httpClient } from 'api';
import {
	StatisticsProgramFeedback,
	StatisticsProgramMentee,
	StatisticsProgramMentor,
	StatisticsProgramProgress,
	StatisticsProgramSummary,
} from 'types/Statistics';

interface SessionComment {
	id: string;
	sessionId: number;
	pairId: number;
	userDisplayName: string;
	date: Date | string;
	sessionNumber: number;
	comment: string;
}

interface SessionCommentsResponse {
	data: SessionComment[];
	pagination: {
		currentPage: number;
		itemsPerPage: number;
		all: number;
		pages: number;
	};
}

interface GetSessionCommentsParams {
	programId: number;
	type: 'mentor' | 'mentee';
	page: number;
	sort: {
		field: string;
		order: 'asc' | 'desc';
	};
}

export const statisticsApi = {
	getSummary: (programId: number) => httpClient.get<StatisticsProgramSummary>(`/statistics/${programId}/summary`),
	getProgress: (programId: number) => httpClient.get<StatisticsProgramProgress>(`/statistics/${programId}/progress`),
	getMentee: (programId: number) => httpClient.get<StatisticsProgramMentee>(`/statistics/${programId}/mentee`),
	getMentor: (programId: number) => httpClient.get<StatisticsProgramMentor>(`/statistics/${programId}/mentor`),
	getFeedback: (programId: number, userType?: 'mentors' | 'mentees') =>
		httpClient.get<StatisticsProgramFeedback>(
			`/statistics/${programId}/feedback${userType ? `?userType=${userType}` : ''}`
		),
	refreshFeedbackStats: async (programId: number, userType?: 'mentors' | 'mentees') => {
		await httpClient.delete(`/statistics/${programId}/feedback/cache`);
		return httpClient.get<StatisticsProgramFeedback>(
			`/statistics/${programId}/feedback${userType ? `?userType=${userType}` : ''}`
		);
	},
	clearCache: (programId: number) => httpClient.delete(`/statistics/${programId}/cache`),
	downloadXlsx: (programId: number) =>
		httpClient.get<Blob>(`/statistics/${programId}/xlsx`, undefined, { responseType: 'blob' }),
	getSessionComments: async (params: GetSessionCommentsParams): Promise<SessionCommentsResponse> => {
		const response: SessionCommentsResponse = await httpClient.get(
			`/statistics/${params.programId}/session-comments`,
			{
				type: params.type,
				page: params.page,
				sortField: params.sort.field,
				sortOrder: params.sort.order,
			}
		);
		return response;
	},
};
